export default{
    'noAccount': ['没有账号?', '已有账号?'],
    'register': ['立即注册', '立即登录', '立即预登记'],
    'browser': '推荐使用Google浏览器，以体验最佳效果',
    'browser1': '推荐使用',
    'browser2': 'Google',
    'browser3': '或',
    'browser4': 'IE11',
    'browser5': '浏览器，以体验最佳效果',
    'resigerTitle': '账号信息',
    'changeResiger': ['切换手机号注册', '切换邮箱注册'],
    'btnText': ['登  录', '注  册'],
    'companyInfo': '公司信息',
    'personInfo': '个人信息',
    'overseasCompanyInfo': '海外总部公司信息',
    'back': '返回上一步',
    'validateFail': '表单验证失败',
    'notAccount': '该邮箱未注册，是否立即注册',
    'notAccount2': '该手机号未注册，是否立即注册',
    'anotherAccount': '您可以使用其他账户登录',
    'fillInformation': '填写登记信息',
    'bringInInformation': '点此带入公司信息'
}